import script from "./DiscussionDetailsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DiscussionDetailsPage.vue?vue&type=script&setup=true&lang=js"

import "./DiscussionDetailsPage.vue?vue&type=style&index=0&id=a03d4462&lang=css"

const __exports__ = script;

export default __exports__